"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/companySlider.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { FC, ComponentProps } from "react";

type HomeNineCompanySliderCompanyLogosItem = {
    /** Detected variants: "assets/img/company/company-nine-1.svg" | "assets/img/company/company-nine-2.svg" | "assets/img/company/company-nine-3.svg" | "assets/img/company/company-nine-4.svg" | "assets/img/company/company-nine-5.svg" | "assets/img/company/company-nine-6.svg" */
    src: string;
    /** Detected variants: "assets/img/company/company-nine-1.svg" | "assets/img/company/company-nine-2.svg" | "assets/img/company/company-nine-3.svg" | "assets/img/company/company-nine-4.svg" | "assets/img/company/company-nine-5.svg" | "assets/img/company/company-nine-6.svg" */
    text: string;
    /** Detected variants: "company logo" */
    alt?: string;
};
export type HomeNineCompanySliderGeneratedProps = {
    companyLogos?: HomeNineCompanySliderCompanyLogosItem[];
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeNineCompanySliderGenerated: FC<HomeNineCompanySliderGeneratedProps> = ({
    companyLogos = [],
    sectionDataWowDuration = "1s",
    sectionDiv0Swiper0SwiperProps,
}) => {
    return (
        <section className="company-section-nine pb-0 section wow fadeOut" data-wow-duration={sectionDataWowDuration}>
            <div className="container">
                <Swiper modules={[Autoplay]} loop={true} speed={10000} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }} slidesPerView={6} slidesPerGroup={1} spaceBetween={0} className="company-slider" breakpoints={{
                    1400: { slidesPerView: 6 },
                    1200: { slidesPerView: 4 },
                    992: { slidesPerView: 3 },
                    768: { slidesPerView: 2 },
                    0: { slidesPerView: 2 }
                }} {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {companyLogos.map((logo, index) => (
                        <SwiperSlide key={index} className="slide-item">
                            <SmartImage src={logo.src} alt={logo.alt ?? "company logo"} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default HomeNineCompanySliderGenerated;
